import http from "../http";
import { CustomAxiosError } from "../../helpers/customErrors";

export default {
  async loginApi(data) {
    try {
      const response = await http().post("auth/login", data);
      return response.data;
    } catch (error) {
      throw new CustomAxiosError(error.response?.data || error.message);
    }
  },

  async logoutApi() {
    try {
      const response = await http().post("auth/logout");
      return response.data;
    } catch (error) {
      throw new CustomAxiosError(error.response?.data || error.message);
    }
  },

  async refreshApi() {
    try {
      const response = await http().post("auth/refresh");
      return response.data;
    } catch (error) {
      throw new CustomAxiosError(error.response?.data || error.message);
    }
  },

  async meApi() {
    try {
      const response = await http().get("auth/me");
      return response.data;
    } catch (error) {
      throw new CustomAxiosError(error.response?.data || error.message);
    }
  },

  async verifySsoApi(data) {
    try {
      const response = await http().post("auth/sso/verify", data);
      return response.data;
    } catch (error) {
      throw new CustomAxiosError(error.response?.data || error.message);
    }
  },
};
